import React from 'react';
import { autobind } from 'core-decorators';
import http from 'src/services/httpService';
import Button from '../../componentes/button';
import Input from '../../componentes/input';
import ContentManager from '../../componentes/content-manager';
import Numero from './componentes/numero';
import DataInicioTermino from './componentes/inicio-termino';
import Alert from '../../componentes/message-box/alert';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { capitalizeFirstLetter } from '../../utils/string';
import {
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import ItemLookup from '../../lookups/item';
import PontoFaixaResultadoLookup from '../../lookups/ponto-faixa-resultado';
import FuncaoLookup from '../../lookups/funcao';
import CategoriaLookup from '../../lookups/categoria';
import CondicionanteLookup from '../../lookups/condicionante';
import ColaboradorSimplificadoLookup from '../../lookups/ColaboradorSimplificadoLookup';
import ItemOrganizacaoLookup from '../../lookups/item-organizacao';
import FormulaPadraoLookup from '../../lookups/formula-padrao';
import Edit from '../../componentes/edit/edit-dialog';
import { MODULOS } from 'src/utils/constants';
import CriteriosAvaliacaoLookup from 'src/lookups/CriteriosAvaliacaoLookup';
import Confirm from '../../componentes/message-box/confirm';
import BasicFunctionModal from './componentes/modals/BasicFunctionModal';
import ConditionalFunctionModal from './componentes/modals/ConditionalFunctionModal';
import SmartVariableCalculationSelector from './componentes/shared/SmartVariableCalculationSelector';
import { translateVariableTerm } from './utils/termTranslator';
import {
  createFormattedFunctionDropdownItem,
  createConditionalFunctionDropdownItem,
  createModalFunctionDropdownItem,
} from './utils/dropdownHelpers';

@autobind
class Editor extends React.Component {
  static defaultProps = {
    isItem: true,
    isBonus: false,
  };

  constructor(props) {
    super(props);
    this.isNew = this.props.formula == null ? true : false;
    this.saved = false;
    this.state = {
      validationState: null,
      messageError: '',
      id: this.props.formula ? this.props.formula.id : 0,
      tipo: this.props.tipo ? this.props.tipo : null,
      exluido: false,
      alterado: this.props.formula ? this.props.formula.alterado : false,
      formula: this.props.formula || null,
      currentIndex: this.props.currentIndex,
      funcaoFormula: null,
      desdobramento: null,
      utilizarCurvaS: false,
      esconderEditor: false,
      permitirDigitacaoValores: false,
      showConfirmLimpar: false,
      showFunctionModal: false,
      functionModalType: null,
      showConditionalModal: false,
      cursorPosition: 0,
    };
  }

  componentDidMount() {
    http
      .post(`/ItemConfiguracao/ObterConfiguracaoValorProjeto`, {})
      .then((response) => {
        this.setState({
          utilizarCurvaS: response.data.utilizarCurvaS,
          permitirDigitacaoValores: response.data.permitirDigitacaoValores,
        });
      });

    let tipo = this.props.parameters.tipoValorId;
    let tipoItemId = this.props.tipoItemId;

    switch (tipo) {
      case 1:
        if (tipoItemId === 3) {
          this.setState({ funcaoFormula: 'Desempenho' });
        } else {
          this.setState({ funcaoFormula: 'Meta' });
        }
        break;
      case 2:
        if (tipoItemId === 3) {
          this.setState({ funcaoFormula: 'Desempenho' });
        } else {
          if (this.props.isItem) {
            this.setState({ funcaoFormula: 'Meta' });
          } else {
            this.setState({ funcaoFormula: 'RealizadoAcumulado' });
          }
        }
        break;
      case 4:
        if (tipoItemId === 3) {
          this.setState({ funcaoFormula: 'DesempenhoAcumulado' });
        } else {
          this.setState({ funcaoFormula: 'MetaAcumulado' });
        }
        break;
      case 5:
        if (tipoItemId === 3) {
          this.setState({ funcaoFormula: 'DesempenhoAcumulado' });
        } else {
          this.setState({ funcaoFormula: 'RealizadoAcumulado' });
        }
        break;
      default:
    }
  }

  handleValidate() {
    this.setState({
      validationState: 'validating',
    });

    http
      .post(`/Formula/ValidarFormula`, {
        formula: this.props.model.getModel('expressao').value,
      })
      .then((response) => {
        this.setState({
          validationState: response.data.error ? 'error' : null,
          messageError: response.data.message,
        });

        if (!response.data.error) {
          ContentManager.addContent(
            <Alert
              title={<FormattedMessage id="sucesso" />}
              message={
                <FormattedMessage id="label.formulaValidadaComSucesso" />
              }
            />
          );
        }
      });
  }

  insertAtCursor(myValue) {
    let myField = document.getElementById('formula');
    //IE support
    if (document.selection) {
      myField.focus();
      let sel = document.selection.createRange();
      sel.text = myValue;
    }
    // Microsoft Edge
    else if (window.navigator.userAgent.indexOf('Edge') > -1) {
      let startPos = myField.selectionStart;
      let endPos = myField.selectionEnd;

      myField.value =
        myField.value.substring(0, startPos) +
        myValue +
        myField.value.substring(endPos, myField.value.length);

      let pos = startPos + myValue.length;
      myField.focus();
      myField.setSelectionRange(pos, pos);
    }
    //MOZILLA and others
    else if (myField.selectionStart || myField.selectionStart == '0') {
      myField.focus();
      let startPos = myField.selectionStart;
      let endPos = myField.selectionEnd;
      myField.value =
        myField.value.substring(0, startPos) +
        myValue +
        myField.value.substring(endPos, myField.value.length);
    } else {
      myField.value += myValue;
    }
    this.props.model.getModel('expressao').requestChange(myField.value);
  }

  insertAtPosition(value, position) {
    const modelField = this.props.model.getModel('expressao');
    const current = modelField.value || '';
    const newValue =
      current.substring(0, position) + value + current.substring(position);
    modelField.requestChange(newValue);
  }

  handleOpenFunctionModal(tipo) {
    const textArea = document.getElementById('formula');
    const cursorPos = textArea
      ? textArea.selectionStart
      : (this.props.model.getModel('expressao').value || '').length;

    this.setState({
      showFunctionModal: true,
      functionModalType: tipo,
      cursorPosition: cursorPos,
    });
  }

  handleCloseFunctionModal = () => {
    this.setState({ showFunctionModal: false, functionModalType: null });
  };

  handleInsertFunction = (expr) => {
    this.insertAtPosition(expr, this.state.cursorPosition);
    this.handleCloseFunctionModal();
  };

  handleOpenConditionalModal = () => {
    const textArea = document.getElementById('formula');
    const cursorPos = textArea
      ? textArea.selectionStart
      : (this.props.model.getModel('expressao').value || '').length;

    this.setState({
      showConditionalModal: true,
      cursorPosition: cursorPos,
    });
  };

  handleCloseConditionalModal = () => {
    this.setState({ showConditionalModal: false });
  };

  handleInsertConditionalFunction = (expr) => {
    this.insertAtPosition(expr, this.state.cursorPosition);
    this.handleCloseConditionalModal();
  };

  handleAddItemFormula(valor) {
    this.insertAtCursor(valor);
  }

  handleCheckFormula() {
    this.handleValidate();
  }

  handleRemoverTudo() {
    this.setState({ showConfirmLimpar: true });
  }

  handleConfirmLimpar() {
    this.props.model.getModel('expressao').requestChange('');
    this.setState({ showConfirmLimpar: false });
  }

  handleCancelLimpar() {
    this.setState({ showConfirmLimpar: false });
  }

  handleNumeroClick() {
    ContentManager.addContent(
      <Numero onRequestClose={this.handleNumeroRequestClose} />
    );
  }

  handleNumeroRequestClose(valor) {
    this.insertAtCursor(valor);
  }

  handleItemChange(tipo, value) {
    this.props.model.getModel(tipo).requestChange(value);
    if (value) {
      this.handleCustomSelectSearch(tipo, value);
    }
  }

  handleCustomSelectSearch(tipo, item) {
    let { funcaoFormula } = this.state;
    let model = this.props.model;

    if (item) {
      let itemId = item.idIntegracao;

      if (tipo === 'condicionante') {
        funcaoFormula = 'Condicionante';
      } else if (tipo === 'organizacaoScore') {
        funcaoFormula = 'ScoreArea';
      } else if (tipo === 'colaboradorScore') {
        funcaoFormula = 'ScoreColaborador';
      } else if (tipo === 'colaboradorNotaMetaIndividual') {
        funcaoFormula = 'NotaMetaIndividual';
      } else if (tipo === 'criterios') {
        funcaoFormula = 'CriteriosAvaliacao';
      }

      const paramDefaultPreviusYears =
        funcaoFormula == 'MetaAnoAnterior' ||
        funcaoFormula == 'RealizadoAnoAnterior' ||
        funcaoFormula == 'MetaAcumuladoAnoAnterior' ||
        funcaoFormula == 'RealizadoAcumuladoAnoAnterior'
          ? ',1'
          : '';

      let valorFormatado = `${funcaoFormula}([${itemId}]${paramDefaultPreviusYears})`;
      this.insertAtCursor(valorFormatado);
      this.setState({ alterado: true });

      this.props.parameters.alterado = true;

      model.getModel('item').requestChange(null);
    }

    this.setState({ desdobramento: null });
  }

  handleDesdobramentoChange(value) {
    this.setState({ desdobramento: value });
    if (value) {
      const desdobramentoPriorizacao = value.desdobramentoPriorizacao;
      if (desdobramentoPriorizacao && desdobramentoPriorizacao.length === 1) {
        const model = this.props.model.getModel('desdobramentoPriorizacao');
        model.requestChange(desdobramentoPriorizacao[0]);
      }
    } else {
      const model = this.props.model.getModel('desdobramentoPriorizacao');
      model.requestChange(null);
    }
  }

  handleChangeValue(field, value) {
    this.props.model.getModel(field).requestChange(value);
    this.props.parameters.alterado = true;
  }

  getTiposIdsSelecionaveis(tipoItemId, hasBelt = false) {
    //retorna lista de tipos de itens que podem ser selecionados no lookup de item
    if (tipoItemId === 12 || tipoItemId === 13 || tipoItemId === 14) {
      return [12, 13, 14];
    } else if (tipoItemId === 10) {
      return [1, 2, 3, 11];
    } else if (
      this.state.utilizarCurvaS ||
      this.state.permitirDigitacaoValores
    ) {
      //se estiver configurado para utlizar curvaS ou permitir digitação de valores libera a inclusão de projetos na fórmula
      return hasBelt ? [1, 2, 3, 4, 17] : [1, 2, 3, 4];
    } else if (tipoItemId === 17) return [1, 17];
    else {
      return hasBelt ? [1, 2, 3, 17] : [1, 2, 3];
    }
  }

  render() {
    const propriedades = {
      resources: this.props.resources,
      modulosPermitidos: this.props.modulosPermitidos,
      intl: this.props.intl,
      isItem: this.props.isItem,
      ignorarItemTabelaValor: this.props.ignorarItemTabelaValor,
      model: this.props.model,
      moduloAtual: this.props.moduloAtual.id,
    };

    const {
      resources,
      modulosPermitidos,
      intl,
      isItem,
      ignorarItemTabelaValor,
      model,
      moduloAtual,
    } = propriedades;

    const { funcaoFormula } = this.state;

    let item =
      model.getModel('itemOrigem') && model.getModel('itemOrigem').value;
    let tipoValor =
      model.getModel('tipo') &&
      model.getModel('tipo').value &&
      model.getModel('tipo').value.id;
    let tipoItem =
      model.getModel('itemOrigem') &&
      model.getModel('itemOrigem').value &&
      model.getModel('itemOrigem').value.tipo &&
      model.getModel('itemOrigem').value.tipo.id;
    let tipoEntidade =
      model.getModel('tipoEntidade') &&
      model.getModel('tipoEntidade').value &&
      model.getModel('tipoEntidade').value.id;

    const isCestaIndicadores =
      tipoEntidade == 3 || tipoEntidade == 7 || tipoEntidade == 8;

    const hasLift = modulosPermitidos.find(
      (m) => m.id === MODULOS.AVALIACAO_DESEMPENHO && m.ativo
    );

    const hasScore = modulosPermitidos.find(
      (m) => m.id === MODULOS.REMUNERACAO_VARIAVEL && m.ativo
    );

    const hasBelt = modulosPermitidos.find(
      (m) => m.id === MODULOS.GESTAO_RISCO && m.ativo
    );

    return (
      <div style={{ paddingBottom: '1rem' }}>
        <style>{`.dropdown-menu-fx-top { top: 16% !important; }`}</style>
        <Row>
          {(this.props.parameters.padrao ||
            (!isCestaIndicadores &&
              tipoEntidade !== 4 &&
              tipoEntidade !== 6)) && (
            <Col md={3}>
              <Input
                model={{
                  label: intl.formatMessage({ id: 'idIntegracao' }),
                  value: model.getModel('idIntegracao').value,
                  requestChange: this.handleChangeValue.bind(
                    this,
                    'idIntegracao'
                  ),
                }}
              />
            </Col>
          )}
          {this.props.parameters.padrao && (
            <Col md={3}>
              <Input
                required
                model={{
                  label: intl.formatMessage({ id: 'descricao' }),
                  value: model.getModel('descricao').value,
                  requestChange: this.handleChangeValue.bind(this, 'descricao'),
                }}
              />
            </Col>
          )}
          {!isCestaIndicadores &&
            tipoEntidade !== 4 &&
            tipoEntidade !== 6 &&
            !this.props.parameters.padrao && (
              <Col md={this.props.isBonus ? 6 : 9}>
                <DataInicioTermino
                  required
                  dataInicio={{
                    label: model.getModel('dataInicio').label,
                    value: model.getModel('dataInicio').value,
                    requestChange: this.handleChangeValue.bind(
                      this,
                      'dataInicio'
                    ),
                    errors: model.getModel('dataInicio').errors,
                  }}
                  dataTermino={{
                    label: model.getModel('dataTermino').label,
                    value: model.getModel('dataTermino').value,
                    requestChange: this.handleChangeValue.bind(
                      this,
                      'dataTermino'
                    ),
                  }}
                />
              </Col>
            )}
          {!this.props.parameters.padrao &&
            !isItem &&
            tipoEntidade != 9 &&
            this.props.isBonus && (
              <Col md={3}>
                <FormulaPadraoLookup
                  model={{
                    label: intl.formatMessage({ id: 'formulaPadrao' }),
                    value: model.getModel('formulaPadrao').value,
                    requestChange: this.handleChangeValue.bind(
                      this,
                      'formulaPadrao'
                    ),
                    errors: model.getModel('formulaPadrao').errors,
                  }}
                  clearable={true}
                  data={{
                    ...propriedades,
                    ...this.props.parameters,
                    padrao: true,
                  }}
                />
              </Col>
            )}
        </Row>
        {!model.getModel('formulaPadrao') ||
          (!model.getModel('formulaPadrao').value && (
            <>
              <div
                style={{ fontWeight: 'bold', fontSize: 15, marginBottom: 12 }}
              >
                <FormattedMessage id="label.editor" />
              </div>
              <div
                className="d-flex align-items-center"
                style={{
                  background: '#F5F5F5',
                  paddingTop: '1rem',
                  paddingBottom: '1rem',
                  borderRadius: '0 0 6px 6px',
                }}
              >
                {/* Variável de cálculo */}
                {tipoEntidade !== 9 && (
                  <div
                    className={`col-md-${
                      funcaoFormula === 'ScoreFuncao'
                        ? 2
                        : this.props.isBonus
                        ? 4
                        : 5
                    }`}
                  >
                    <SmartVariableCalculationSelector
                      isItem={isItem}
                      tipoItem={tipoItem}
                      tipoEntidade={tipoEntidade}
                      isCestaIndicadores={isCestaIndicadores}
                      modulosPermitidos={modulosPermitidos}
                      hasLift={hasLift}
                      hasScore={hasScore}
                      value={this.state.funcaoFormula}
                      onChange={(opcao) => {
                        if (opcao && opcao.id) {
                          if (
                            opcao.id === 'ScoreHierarquiaArea' ||
                            opcao.id === 'ScoreHierarquiaColaborador'
                          ) {
                            this.insertAtCursor(`${opcao.id}()`);
                          } else {
                            this.setState({ funcaoFormula: opcao.id });
                          }
                        }
                      }}
                    />
                  </div>
                )}

                {/* Bloco condicional de campos alternativos */}
                {funcaoFormula !== 'ScoreFuncao' && (
                  <div
                    className={`col-md-${
                      this.props.isBonus ? 4 : 5
                    } flex-grow-1`}
                  >
                    {/* CategoriaLookup para ScoreCategoria em TipoCard */}
                    {tipoEntidade === 4 &&
                      funcaoFormula == 'ScoreCategoria' && (
                        <CategoriaLookup
                          model={{
                            label: intl.formatMessage({ id: 'categoria' }),
                            value: model.getModel('categoria').value,
                            requestChange: this.handleItemChange.bind(
                              this,
                              'categoria'
                            ),
                            errors: model.getModel('categoria').errors,
                          }}
                          clearable={false}
                        />
                      )}

                    {/* ItemLookup padrão */}
                    {funcaoFormula !== 'ScoreCategoria' &&
                      funcaoFormula !== 'PontosPorFaixaTransformada' &&
                      funcaoFormula !== 'notaMetaIndividual' &&
                      funcaoFormula !== 'ScoreHierarquiaArea' &&
                      funcaoFormula !== 'ScoreHierarquiaColaborador' &&
                      tipoEntidade != 9 && (
                        <ItemLookup
                          className="inline-block"
                          data={{
                            tiposIdsSelecionados: this.getTiposIdsSelecionaveis(
                              tipoItem,
                              hasBelt
                            ),
                            periodicidadeIdSuperior:
                              item && item.periodicidade
                                ? item.periodicidade.id
                                : 9,
                            ignorarItemTabelaValor: ignorarItemTabelaValor,
                            desdobramentoId:
                              model.getModel('desdobramento').value &&
                              model.getModel('desdobramento').value.id,
                            periodicidadeId:
                              funcaoFormula == 'MetaAnoAnterior' ||
                              funcaoFormula == 'RealizadoAnoAnterior' ||
                              funcaoFormula == 'MetaAcumuladoAnoAnterior' ||
                              funcaoFormula == 'RealizadoAcumuladoAnoAnterior'
                                ? item?.periodicidade.id
                                : null,
                          }}
                          model={{
                            label: intl.formatMessage({ id: 'item' }),
                            value: model.getModel('item').value,
                            requestChange: this.handleItemChange.bind(
                              this,
                              'item'
                            ),
                          }}
                        />
                      )}

                    {/* ColaboradorSimplificadoLookup para notaMetaIndividual */}
                    {(tipoEntidade === 2 ||
                      isCestaIndicadores ||
                      tipoEntidade === 4 ||
                      tipoEntidade === 6) &&
                      funcaoFormula == 'notaMetaIndividual' && (
                        <ColaboradorSimplificadoLookup
                          model={{
                            label: capitalizeFirstLetter(resources.colaborador),
                            value: model.getModel(
                              'colaboradorNotaMetaIndividual'
                            ).value,
                            requestChange: this.handleItemChange.bind(
                              this,
                              'colaboradorNotaMetaIndividual'
                            ),
                          }}
                        />
                      )}

                    {/* PontoFaixaResultadoLookup para PontosPorFaixaTransformada */}
                    {(tipoEntidade === 2 || isCestaIndicadores) &&
                      funcaoFormula === 'PontosPorFaixaTransformada' && (
                        <PontoFaixaResultadoLookup
                          model={{
                            label: intl.formatMessage({
                              id: 'label.pontosFaixaResultado',
                            }),
                            value: model.getModel('pontosFaixaTransformada')
                              .value,
                            requestChange: this.handleItemChange.bind(
                              this,
                              'pontosFaixaTransformada'
                            ),
                          }}
                          data={{ tipoPontoFaixaResultadoId: 1 }}
                        />
                      )}
                  </div>
                )}

                {/* Campo de Condicionante (apenas para bônus) */}
                {this.props.isBonus && (
                  <div
                    className={`col-md-${
                      funcaoFormula === 'ScoreFuncao' ? 2 : 3
                    } `}
                  >
                    <CondicionanteLookup
                      model={{
                        label: capitalizeFirstLetter(resources.condicionante),
                        value: model.getModel('condicionante').value,
                        requestChange: this.handleItemChange.bind(
                          this,
                          'condicionante'
                        ),
                      }}
                      clearable={false}
                    />
                  </div>
                )}

                {/* FuncaoLookup, ColaboradorSimplificadoLookup, ItemOrganizacaoLookup para ScoreFuncao */}
                {(tipoEntidade === 2 ||
                  isCestaIndicadores ||
                  tipoEntidade === 4 ||
                  tipoEntidade === 6) &&
                  funcaoFormula == 'ScoreFuncao' && (
                    <>
                      <div className="col-md-2">
                        <FuncaoLookup
                          model={{
                            label: capitalizeFirstLetter(resources.funcao),
                            value: model.getModel('funcao').value,
                            requestChange: this.handleItemChange.bind(
                              this,
                              'funcao'
                            ),
                            errors: model.getModel('funcao').errors,
                          }}
                          clearable={false}
                        />
                      </div>
                      <div className="col-md-3">
                        <ColaboradorSimplificadoLookup
                          model={{
                            label: capitalizeFirstLetter(resources.colaborador),
                            value: model.getModel('colaboradorScore').value,
                            requestChange: this.handleItemChange.bind(
                              this,
                              'colaboradorScore'
                            ),
                          }}
                        />
                      </div>
                      <div className="col-md-2">
                        <ItemOrganizacaoLookup
                          model={{
                            label: capitalizeFirstLetter(resources.area),
                            value: model.getModel('organizacaoScore').value,
                            requestChange: this.handleItemChange.bind(
                              this,
                              'organizacaoScore'
                            ),
                          }}
                        />
                      </div>
                    </>
                  )}

                {/* Botão Funções (fx) */}
                <UncontrolledDropdown
                  className={`col-md-${
                    this.props.isBonus ? 1 : 2
                  } d-flex align-items-center justify-content-center align-self-end mb-3`}
                >
                  <DropdownToggle color="primary" style={{ minWidth: 40 }}>
                    <span
                      style={{
                        fontFamily: 'monospace',
                        fontWeight: 'bold',
                        fontSize: 18,
                        fontStyle: 'italic',
                      }}
                    >
                      f<sub>X</sub>
                    </span>
                  </DropdownToggle>
                  <DropdownMenu
                    end
                    modifiers={[
                      {
                        name: 'offset',
                        options: {
                          offset: [-70, 8],
                        },
                      },
                    ]}
                    style={{
                      marginTop: 40,
                      overflowY: 'auto',
                      maxHeight: 272,
                      minWidth: 180,
                      maxWidth: 400,
                    }}
                  >
                    {/* Operadores lógicos */}
                    {createFormattedFunctionDropdownItem(
                      'label.se',
                      'se(',
                      true,
                      {},
                      this.handleAddItemFormula
                    )}
                    {createFormattedFunctionDropdownItem(
                      'maior',
                      '>',
                      true,
                      {},
                      this.handleAddItemFormula
                    )}
                    {createFormattedFunctionDropdownItem(
                      'label.maiorOuIgual',
                      '>=',
                      true,
                      {},
                      this.handleAddItemFormula
                    )}
                    {createFormattedFunctionDropdownItem(
                      'menor',
                      '<',
                      true,
                      {},
                      this.handleAddItemFormula
                    )}
                    {createFormattedFunctionDropdownItem(
                      'label.menorOuIgual',
                      '<=',
                      true,
                      {},
                      this.handleAddItemFormula
                    )}
                    {createFormattedFunctionDropdownItem(
                      'igual',
                      '=',
                      true,
                      {},
                      this.handleAddItemFormula
                    )}
                    {createFormattedFunctionDropdownItem(
                      'label.diferente',
                      '!=',
                      true,
                      {},
                      this.handleAddItemFormula
                    )}
                    {createFormattedFunctionDropdownItem(
                      'label.e',
                      'e',
                      true,
                      {},
                      this.handleAddItemFormula
                    )}
                    {createFormattedFunctionDropdownItem(
                      'label.ou',
                      'ou',
                      true,
                      {},
                      this.handleAddItemFormula
                    )}
                    {createFormattedFunctionDropdownItem(
                      'label.not',
                      '!',
                      true,
                      {},
                      this.handleAddItemFormula
                    )}

                    {/* Funções de período */}
                    {createConditionalFunctionDropdownItem(
                      'label.nDePeriodos',
                      'NumeroPeriodos()',
                      tipoValor === 5 || tipoValor === 4,
                      {},
                      null,
                      this.handleAddItemFormula
                    )}
                    {createConditionalFunctionDropdownItem(
                      'label.nDePeriodosRealizados',
                      'NumeroPeriodosRealizados()',
                      tipoValor === 5 || tipoValor === 4,
                      {},
                      null,
                      this.handleAddItemFormula
                    )}

                    {/* Funções de itens */}
                    {createConditionalFunctionDropdownItem(
                      'nDeItensComValor',
                      'NumeroItensComValor()',
                      moduloAtual != MODULOS.GESTAO_RISCO,
                      {},
                      null,
                      this.handleAddItemFormula
                    )}
                    {createConditionalFunctionDropdownItem(
                      'label.nDeItensFormula',
                      'NumeroItens()',
                      moduloAtual != MODULOS.GESTAO_RISCO,
                      {},
                      null,
                      this.handleAddItemFormula
                    )}

                    {/* Funções de salário */}
                    {createConditionalFunctionDropdownItem(
                      'label.ultimoSalario',
                      'UltimoSalario()',
                      !isItem && moduloAtual != MODULOS.GESTAO_RISCO,
                      { salario: resources.salario },
                      null,
                      this.handleAddItemFormula
                    )}
                    {createConditionalFunctionDropdownItem(
                      'label.salarioProRata',
                      'SalarioProRata()',
                      !isItem && moduloAtual != MODULOS.GESTAO_RISCO,
                      { salario: resources.salario },
                      null,
                      this.handleAddItemFormula
                    )}
                    {createConditionalFunctionDropdownItem(
                      '',
                      'Score()',
                      !isItem && moduloAtual != MODULOS.GESTAO_RISCO,
                      {},
                      translateVariableTerm('Score', resources, intl),
                      this.handleAddItemFormula
                    )}

                    {/* Funções específicas de tipoEntidade 8 */}
                    {createConditionalFunctionDropdownItem(
                      'salarioAcumulado',
                      'SalarioAcumulado()',
                      tipoEntidade === 8,
                      { salario: resources.salario },
                      null,
                      this.handleAddItemFormula
                    )}
                    {createConditionalFunctionDropdownItem(
                      'performance',
                      'Performance()',
                      tipoEntidade === 8,
                      {},
                      null,
                      this.handleAddItemFormula
                    )}

                    {/* Funções de avaliação */}
                    {createConditionalFunctionDropdownItem(
                      'resultadoCicloAvaliacao',
                      'ResultadoCicloAvaliacao()',
                      hasLift && tipoEntidade === 2,
                      { cicloavaliacao: resources.cicloavaliacao },
                      null,
                      this.handleAddItemFormula
                    )}

                    {/* Funções matemáticas */}
                    {createFormattedFunctionDropdownItem(
                      'label.menorValor',
                      'MenorValor(',
                      true,
                      {},
                      this.handleAddItemFormula
                    )}
                    {createFormattedFunctionDropdownItem(
                      'label.maiorValor',
                      'MaiorValor(',
                      true,
                      {},
                      this.handleAddItemFormula
                    )}
                    {createFormattedFunctionDropdownItem(
                      'label.arredondar',
                      'Arredondar(',
                      true,
                      {},
                      this.handleAddItemFormula
                    )}
                    {createConditionalFunctionDropdownItem(
                      'label.transformada',
                      'Transformada(',
                      tipoEntidade === 2 || isCestaIndicadores,
                      {},
                      null,
                      this.handleAddItemFormula
                    )}

                    <DropdownItem divider />

                    {/* Funções modais */}
                    {createModalFunctionDropdownItem(
                      'soma',
                      'soma',
                      this.handleOpenFunctionModal
                    )}
                    {createModalFunctionDropdownItem(
                      'produtoMultiplicacao',
                      'produto',
                      this.handleOpenFunctionModal
                    )}
                    {createModalFunctionDropdownItem(
                      'media',
                      'media',
                      this.handleOpenFunctionModal
                    )}
                    {createModalFunctionDropdownItem(
                      'mediaPonderada',
                      'mediaPonderada',
                      this.handleOpenFunctionModal
                    )}
                    <DropdownItem
                      key="funcaoCondicional"
                      onClick={this.handleOpenConditionalModal}
                    >
                      <span>
                        <FormattedMessage id="condicional" />
                      </span>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>

              <Row className="mt-2">
                {tipoEntidade === 9 && (
                  <Col md={6}>
                    <CriteriosAvaliacaoLookup
                      model={{
                        label: capitalizeFirstLetter(
                          intl.formatMessage({ id: 'labelCriteriosAvaliacao' })
                        ),
                        value: model.getModel('criterios').value,
                        requestChange: this.handleItemChange.bind(
                          this,
                          'criterios'
                        ),
                      }}
                    />
                  </Col>
                )}
              </Row>

              <Row className="mt-2">
                <Col md={12}>
                  <Input
                    id="formula"
                    autoFocus
                    rows={7}
                    type="textarea"
                    validationState={this.state.validationState}
                    model={{
                      label: intl.formatMessage({ id: 'label.expressao' }),
                      value: model.getModel('expressao').value,
                      requestChange: this.handleChangeValue.bind(
                        this,
                        'expressao'
                      ),
                    }}
                  ></Input>
                  {this.state.validationState === 'error' && (
                    <span style={{ color: '#f05050' }}>
                      {this.state.messageError}
                    </span>
                  )}
                </Col>
              </Row>
            </>
          ))}

        {/* Modal de confirmação para limpar */}
        {this.state.showConfirmLimpar && (
          <Confirm
            title={intl.formatMessage({ id: 'label.limparFormula' })}
            message={intl.formatMessage({
              id: 'temCertezaQueDesejaLimparAFormula',
            })}
            labelCancel={intl.formatMessage({ id: 'label.cancelar' })}
            labelConfirm={intl.formatMessage({ id: 'limpar' })}
            handleCancel={this.handleCancelLimpar}
            handleConfirm={this.handleConfirmLimpar}
          />
        )}

        {/* Modal de Soma / Produto / Média */}
        {this.state.showFunctionModal &&
          (() => {
            const titleMap = {
              soma: 'soma',
              produto: 'produtoMultiplicacao',
              media: 'media',
              mediaPonderada: 'mediaPonderada',
            };
            const titleId =
              titleMap[this.state.functionModalType] ||
              this.state.functionModalType;

            return (
              <BasicFunctionModal
                isOpen={this.state.showFunctionModal}
                tipo={this.state.functionModalType}
                titulo={<FormattedMessage id={titleId} />}
                isItem={isItem}
                tipoItem={tipoItem}
                tipoEntidade={tipoEntidade}
                isCestaIndicadores={isCestaIndicadores}
                modulosPermitidos={modulosPermitidos}
                hasLift={hasLift}
                hasScore={hasScore}
                intl={intl}
                onInsert={this.handleInsertFunction}
                onRequestClose={this.handleCloseFunctionModal}
              />
            );
          })()}

        {/* Modal de Função Condicional */}
        {this.state.showConditionalModal && (
          <ConditionalFunctionModal
            isOpen={this.state.showConditionalModal}
            titulo={<FormattedMessage id="condicional" />}
            isItem={isItem}
            tipoItem={tipoItem}
            tipoEntidade={tipoEntidade}
            isCestaIndicadores={isCestaIndicadores}
            modulosPermitidos={modulosPermitidos}
            hasLift={hasLift}
            hasScore={hasScore}
            intl={intl}
            onInsert={this.handleInsertConditionalFunction}
            onRequestClose={this.handleCloseConditionalModal}
          />
        )}
      </div>
    );
  }
}

@autobind
class FormulaEdit extends React.Component {
  constructor(props) {
    super(props);
    this.editorRef = React.createRef();
  }

  renderCustomButtons = () => {
    return [
      <Button
        color="link"
        key="limpar"
        onClick={() => {
          if (this.editorRef.current) {
            this.editorRef.current.handleRemoverTudo();
          }
        }}
      >
        <strong>
          <FormattedMessage id="limpar" />
        </strong>
      </Button>,
      <Button
        color="link"
        key="validar"
        onClick={() => {
          if (this.editorRef.current) {
            this.editorRef.current.handleValidate();
          }
        }}
      >
        <strong>
          <FormattedMessage id="label.validarFormula" />
        </strong>
      </Button>,
    ];
  };

  render() {
    return (
      <Edit
        url="/Formula"
        title="formula"
        formComponent={Editor}
        formComponentRef={this.editorRef}
        renderButtonActions={this.renderCustomButtons}
        botoesCustomLeft={true}
        {...this.props}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
    moduloAtual: state.user.moduloAtual,
    modulosPermitidos: state.user.licenca.modulos,
  };
}

export default injectIntl(connect(mapStateToProps)(FormulaEdit));
